export default [
    {
        path: "/report/offer-document",
        name: "ReportOfferDocument",
        component: () => import("@/views/report/offer-document/OfferIndex.vue"),
        meta: {
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
    {
        path: "/report/spj",
        name: "ReportSpj",
        component: () => import("@/views/report/spj/SpjIndex.vue"),
        meta: {
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
    {
        path: "/report/vehicle-maintenance",
        name: "ReportVehicleMaintenance",
        component: () => import("@/views/report/vehicle-maintenance/VehicleMaintenanceIndex.vue"),
        meta: {
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
];
